<template>
  <div class="driver-shifts">
    <div class="row shift-header">
      <div class="small-3 columns padding-R">
        <div class="field-input">
          <label>FROM:</label>
          <date-picker v-model="startDate" format="MM/dd/yyyy" @selected="filterShifts" :disabled="startDateDisabledDates"
            input-class="drivershift-dateinput" calendar-class="drivershift-calendar"
            v-if="editEnabled"></date-picker>
          <input type="text" v-else disabled="disabled" class="input" :value="dateFormat(startDate)" />
        </div>
      </div>
      <div class="small-3 columns padding-L">
        <div class="field-input">
          <label>TO:</label>
          <date-picker v-model="endDate" format="MM/dd/yyyy" @selected="filterShifts" :disabled="endDateDisabledDates"
            input-class="drivershift-dateinput" calendar-class="drivershift-calendar"
            v-if="editEnabled"></date-picker>
          <input type="text" v-else disabled="disabled" class="input" :value="dateFormat(endDate)" />
        </div>
      </div>
      <div class="small-2 columns"></div>
      <div class="small-4 columns">
        <a class="button cta xsmall block filter-btn" href="javascript:;"
          @click="addNewShift(null, null, null)" v-if="editEnabled">
          <span>ADD NEW AVAILABILITY</span>
        </a>
      </div>
    </div>

    <div :class="{'home-sector':true, 'disabled':!editEnabled}">
      <div v-if="homeSector !== null" @click="openHomeSector">
        <i class="fa fa-home"></i>
        <span>Home Sector is set to</span>
        <span class="highlight">{{ homeSector }}</span>
        <i class="fa fa-edit" v-if="editEnabled"></i>
      </div>
      <div v-else class="none" @click="openHomeSector">
        <i class="fa fa-home"></i>
        <span>No Home Sector set for this driver.</span>
        <i class="fa fa-edit" v-if="editEnabled"></i>
      </div>
    </div>

    <div class="shifts">
      <div class="shift-dates">
        <div class="shift-day-empty"></div>
        <div class="shift-day" v-for="day in days">
          <div class="date">{{ day.format('DD') }}</div>
          <div class="month">{{ day.format('MMM') }}</div>
          <div class="day">{{ day.format('ddd') }}</div>
        </div>
      </div>

      <div :class="{'shift-times-wrapper':true, 'disabled':!editEnabled}">
        <div class="shift-times">
          <div class="time-labels">
            <div class="time-label">12:00 AM</div>
            <div class="time-label">01:00 AM</div>
            <div class="time-label">02:00 AM</div>
            <div class="time-label">03:00 AM</div>
            <div class="time-label">04:00 AM</div>
            <div class="time-label">05:00 AM</div>
            <div class="time-label">06:00 AM</div>
            <div class="time-label">07:00 AM</div>
            <div class="time-label">08:00 AM</div>
            <div class="time-label">09:00 AM</div>
            <div class="time-label">10:00 AM</div>
            <div class="time-label">11:00 AM</div>
            <div class="time-label">12:00 PM</div>
            <div class="time-label">01:00 PM</div>
            <div class="time-label">02:00 PM</div>
            <div class="time-label">03:00 PM</div>
            <div class="time-label">04:00 PM</div>
            <div class="time-label">05:00 PM</div>
            <div class="time-label">06:00 PM</div>
            <div class="time-label">07:00 PM</div>
            <div class="time-label">08:00 PM</div>
            <div class="time-label">09:00 PM</div>
            <div class="time-label">10:00 PM</div>
            <div class="time-label">11:00 PM</div>
          </div>
        </div>
        <div class="shift-placeholder-row" v-for="day in days">
          <div class="shift-placeholder" @click="addNewShift(day, 12, 'AM')"></div>
          <div class="shift-placeholder" @click="addNewShift(day, 1, 'AM')"></div>
          <div class="shift-placeholder" @click="addNewShift(day, 2, 'AM')"></div>
          <div class="shift-placeholder" @click="addNewShift(day, 3, 'AM')"></div>
          <div class="shift-placeholder" @click="addNewShift(day, 4, 'AM')"></div>
          <div class="shift-placeholder" @click="addNewShift(day, 5, 'AM')"></div>
          <div class="shift-placeholder" @click="addNewShift(day, 6, 'AM')"></div>
          <div class="shift-placeholder" @click="addNewShift(day, 7, 'AM')"></div>
          <div class="shift-placeholder" @click="addNewShift(day, 8, 'AM')"></div>
          <div class="shift-placeholder" @click="addNewShift(day, 9, 'AM')"></div>
          <div class="shift-placeholder" @click="addNewShift(day, 10, 'AM')"></div>
          <div class="shift-placeholder" @click="addNewShift(day, 11, 'AM')"></div>
          <div class="shift-placeholder" @click="addNewShift(day, 12, 'PM')"></div>
          <div class="shift-placeholder" @click="addNewShift(day, 1, 'PM')"></div>
          <div class="shift-placeholder" @click="addNewShift(day, 2, 'PM')"></div>
          <div class="shift-placeholder" @click="addNewShift(day, 3, 'PM')"></div>
          <div class="shift-placeholder" @click="addNewShift(day, 4, 'PM')"></div>
          <div class="shift-placeholder" @click="addNewShift(day, 5, 'PM')"></div>
          <div class="shift-placeholder" @click="addNewShift(day, 6, 'PM')"></div>
          <div class="shift-placeholder" @click="addNewShift(day, 7, 'PM')"></div>
          <div class="shift-placeholder" @click="addNewShift(day, 8, 'PM')"></div>
          <div class="shift-placeholder" @click="addNewShift(day, 9, 'PM')"></div>
          <div class="shift-placeholder" @click="addNewShift(day, 10, 'PM')"></div>
          <div class="shift-placeholder" @click="addNewShift(day, 11, 'PM')"></div>
        </div>
        <div class="driver-shift" v-for="shift in driverShifts" :style="shift.shiftPosition">
          <div v-bind:class="{ 'shift-content': true, confirmed: shift.confirmed }" @click="editShift(shift)">
            <div class="time">
              <span v-if="shift.startsPrevDay">(-1)</span>
              <span>{{ shift.start.format('hh:mm A') }}</span> - 
              <span>{{ shift.end.format('hh:mm A') }}</span>
              <span v-if="shift.endsNextDay">(+1)</span>
            </div>
            <div class="place">{{ shift.workSectorName }}</div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import moment from 'moment'
import DatePicker from 'vuejs-datepicker'
export default {
  name: 'driver-shifts',
  props: ['active'],
  components: { DatePicker },
  data () {
    return {
      startDate: null,
      endDate: null,
      days: [],
      driverShifts: [],
      homeSector: null,
      loaded: ''
    }
  },
  computed: {
    provId () { return this.$route.params.id },
    startDateDisabledDates () {
      if (this.startDate === null) {
        return {
          to: new Date(1980, 0, 1)
        }
      }
      return {
        from: this.endDate
      }
    },
    endDateDisabledDates () {
      if (this.startDate === null) {
        return {
          to: new Date(1980, 0, 1)
        }
      }
      return {
        to: this.startDate
      }
    },
    isShiftFormSaved () { return this.$store.state.provider.shiftForm.save },
    homeSectorId () { return this.$store.state.provider.basicInfo.homeSectorId },
    // editEnabled () { return this.$store.state.session.user.access.hasOwnProperty('PageAdminProviderEdit') }
    editEnabled () { return true }
  },
  methods: {
    initialize () {
      let self = this
      let start = moment(moment().format('MM/DD/YYYY') + ' 00:00:00AM', 'MM/DD/YYYY hh:mm:ssA')
      let end = moment(moment().add(6, 'days').format('MM/DD/YYYY') + ' 11:59:59PM', 'MM/DD/YYYY hh:mm:ssA')

      if (self.startDate === null && self.endDate === null) {
        self.startDate = start.toDate()
        self.endDate = end.toDate()
      } else { 
        start = moment(self.startDate)
        end = moment(self.endDate)
      }
      end = moment(end.format('MM/DD/YYYY') + ' 11:59:59PM', 'MM/DD/YYYY hh:mm:ssA')

      self.days = []
      for (let m = moment(start); m.diff(end, 'days') <= 0; m.add(1, 'days')) {
        if (m.isAfter(end)) {
          break
        }
        self.days.push(moment(m))
      }
      
      self.$sdk.get('/shifts', {
        token: self.$store.state.session.sessionToken,
        driverId: self.$route.params.id,
        since: moment(self.startDate).unix(),
        until: moment(self.endDate).unix()
      }, r => {
        if (r.error) {
          return
        }
        self.processDriverShifts(r.list)
      })
    },
    processDriverShifts (shifts) {
      let self = this
      self.driverShifts = []

      for (let i = 0; i < shifts.length; i++) {
        let shift = shifts[i]

        let start = moment.unix(shift.startTimestamp)
        let end = moment.unix(shift.endTimestamp)
        let duration = Math.round((shift.endTimestamp - shift.startTimestamp) / 60 / 60)
        let isBugDate = false
        if (end.diff(start, 'days') > 2) {
          end = moment.unix(shift.startTimestamp).add(12, 'hours')
          duration = Math.round((end.format('X') - shift.startTimestamp) / 60 / 60)
          isBugDate = true
        }
        let position = self.buildShiftPosition(start, duration)
        let endsNextDay = false
        
        // check if it shift crosses multiple days
        let startDayStr = start.format('MM/DD/YYYY')
        let endDayStr = end.format('MM/DD/YYYY')
        if (startDayStr !== endDayStr) {
          let tempEnd = moment(endDayStr + ' 12:00AM', 'MM/DD/YYYY hh:mmA')
          let tempDuration = tempEnd.diff(start, 'hours')
          position = self.buildShiftPosition(start, tempDuration)
          endsNextDay = true

          let duration2 = end.diff(tempEnd, 'hours')
          let position2 = self.buildShiftPosition(tempEnd, duration2)

          if (!isBugDate) {
            self.driverShifts.push({
              id: shift.id,
              driverId: shift.driverId,
              start: start,
              end: end,
              duration: duration,
              dayIndex: self.findDayIndex(start),
              startHour: parseInt(start.format('HH')),
              startMinute: parseInt(start.format('mm')),
              shiftPosition: position2,
              homeSectorId: shift.driverHomeSectorId,
              homeSectorName: shift.driverHomeSectorName,
              homeSubsectorId: shift.drivertHomeSubsectorId,
              homeSubsectorName: shift.drivertHomeSubsectorName,
              workSectorId: shift.driverWorkSectorId,
              workSectorName: shift.driverWorkSectorName,
              workSubsectorId: shift.driverWorkSubsectorId,
              workSubsectorName: shift.driverWorkSubsectorName,
              confirmed: shift.driverConfirmed,
              startsPrevDay: true,
              endsNextDay: false
            })
          }
        }
        if (!isBugDate) {
          self.driverShifts.push({
            id: shift.id,
            driverId: shift.driverId,
            start: start,
            end: end,
            duration: duration,
            dayIndex: self.findDayIndex(start),
            startHour: parseInt(start.format('HH')),
            startMinute: parseInt(start.format('mm')),
            shiftPosition: position,
            homeSectorId: shift.driverHomeSectorId,
            homeSectorName: shift.driverHomeSectorName,
            homeSubsectorId: shift.drivertHomeSubsectorId,
            homeSubsectorName: shift.drivertHomeSubsectorName,
            workSectorId: shift.driverWorkSectorId,
            workSectorName: shift.driverWorkSectorName,
            workSubsectorId: shift.driverWorkSubsectorId,
            workSubsectorName: shift.driverWorkSubsectorName,
            confirmed: shift.driverConfirmed,
            startsPrevDay: false,
            endsNextDay: endsNextDay
          })
        }

        // clone dates to fix Over end time
        if (isBugDate && moment.unix(shift.endTimestamp).diff(start, 'days') > 2) {
          let days = moment(self.endDate).diff(moment(self.startDate), 'days')
          let maxDays = moment(shift.endTimestamp, 'X').diff(moment(self.startDate), 'days')
          if (days > maxDays) days = maxDays
          else if (maxDays > days) days++

          for (var i = 0; i < days; i++) {
            let startTime = moment.unix(shift.startTimestamp)
            let endTime = moment.unix(shift.startTimestamp).add(12, 'hours')
            start = moment(self.startDate).add(i, 'days').hour(startTime.format('HH')).minute(startTime.format('mm'))
            end = moment(self.startDate).add(i+1, 'days').hour(endTime.format('HH')).minute(endTime.format('mm'))
            // duration = Math.round((end.format('X') - shift.startTimestamp) / 60 / 60)
            duration = 12
            position = self.buildShiftPosition(start, duration)
            endsNextDay = false
            startDayStr = start.format('MM/DD/YYYY')
            endDayStr = end.format('MM/DD/YYYY')

            // if (startDayStr !== endDayStr) {
            //   let tempEnd = moment(endDayStr + ' 12:00AM', 'MM/DD/YYYY hh:mmA')
            //   let tempDuration = tempEnd.diff(start, 'hours')
            //   position = self.buildShiftPosition(start, tempDuration)
            //   endsNextDay = true

            //   let duration2 = end.diff(tempEnd, 'hours')
            //   let position2 = self.buildShiftPosition(tempEnd, duration2)

            //   self.driverShifts.push({
            //     id: shift.id,
            //     driverId: shift.driverId,
            //     start: start,
            //     end: end,
            //     duration: duration,
            //     dayIndex: self.findDayIndex(start),
            //     startHour: parseInt(start.format('HH')),
            //     startMinute: parseInt(start.format('mm')),
            //     shiftPosition: position2,
            //     homeSectorId: shift.driverHomeSectorId,
            //     homeSectorName: shift.driverHomeSectorName,
            //     homeSubsectorId: shift.drivertHomeSubsectorId,
            //     homeSubsectorName: shift.drivertHomeSubsectorName,
            //     workSectorId: shift.driverWorkSectorId,
            //     workSectorName: shift.driverWorkSectorName,
            //     workSubsectorId: shift.driverWorkSubsectorId,
            //     workSubsectorName: shift.driverWorkSubsectorName,
            //     confirmed: shift.driverConfirmed,
            //     startsPrevDay: true,
            //     endsNextDay: false
            //   })
            // }
            self.driverShifts.push({
              id: shift.id,
              driverId: shift.driverId,
              start: start,
              end: end,
              duration: duration,
              dayIndex: self.findDayIndex(start),
              startHour: parseInt(start.format('HH')),
              startMinute: parseInt(start.format('mm')),
              shiftPosition: position,
              homeSectorId: shift.driverHomeSectorId,
              homeSectorName: shift.driverHomeSectorName,
              homeSubsectorId: shift.drivertHomeSubsectorId,
              homeSubsectorName: shift.drivertHomeSubsectorName,
              workSectorId: shift.driverWorkSectorId,
              workSectorName: shift.driverWorkSectorName,
              workSubsectorId: shift.driverWorkSubsectorId,
              workSubsectorName: shift.driverWorkSubsectorName,
              confirmed: shift.driverConfirmed,
              startsPrevDay: false,
              endsNextDay: endsNextDay
            })
          }
        }
      }
    },
    buildShiftPosition (shiftStart, duration) {
      let self = this
      let format = 'MM/DD/YYYY'

      let dayStart = null
      for (let i = 0; i < self.days.length; i++) {
        let day = self.days[i]
        if (day.format(format) === shiftStart.format(format)) {
          dayStart = i
          break
        }
      }

      let hour = parseInt(shiftStart.format('HH')) - 1
      let minute = parseInt(shiftStart.format('mm'))

      let result = {
        top: (30 + (dayStart * 74)) + 'px',
        left: (60 + (hour * 60) + minute) + 'px',
        width: (duration * 60) + 'px'
      }
      return result
    },
    findDayIndex (shiftStart) {
      let self = this
      let format = 'MM/DD/YYYY'

      for (let i = 0; i < self.days.length; i++) {
        let day = self.days[i]
        if (day.format(format) === shiftStart.format(format)) {
          return i + 1
        }
      }
    },
    filterShifts () {
      let self = this
      setTimeout(() => {
        this.initialize()
      }, 250)
    },
    openHomeSector () {
      let self = this
      if (!self.editEnabled) { return }
      let homeSectorId = -1
      if (self.homeSectorId !== null) {
        homeSectorId = self.homeSectorId
      }
      self.$store.commit('provider/setShiftFormSelectedSector', homeSectorId)
      self.$store.commit('provider/setShiftFormTitle', 'Select the Home Sector')
      self.$store.commit('provider/setShiftFormForHomeSector', true)
      self.$store.commit('provider/setShiftFormShow', true)
    },
    addNewShift (day, hour, ampm) {
      let self = this
      if (!self.editEnabled) { return }
      let selectedSector = -1
      if (self.homeSectorId !== null) {
        selectedSector = self.homeSectorId
      }
      self.$store.commit('provider/setShiftFormSelectedSector', selectedSector)
      self.$store.commit('provider/setShiftFormSelectedSubsector', -1)
      self.$store.commit('provider/setShiftFormShiftId', null)
      self.$store.commit('provider/setShiftFormShiftDuration', 1)
      if (day === null || hour === null || ampm === null) {

        let now = moment()
        let hour = parseInt(now.format('hh'))
        let minute = parseInt(now.format('mm'))
        minute = Math.ceil(minute / 5) * 5
        if (minute > 55) {
          hour = hour + 1
          minute = 0
        }
        if (hour > 12) {
          hour = 1
        }
        self.$store.commit('provider/setShiftFormShiftDay', now.toDate())
        self.$store.commit('provider/setShiftFormTimeHour', hour)
        self.$store.commit('provider/setShiftFormTimeMinute', minute)
        self.$store.commit('provider/setShiftFormTimeAmPm', now.format('A'))
      } else {
        self.$store.commit('provider/setShiftFormShiftDay', day.toDate())
        self.$store.commit('provider/setShiftFormTimeHour', hour)
        self.$store.commit('provider/setShiftFormTimeMinute', 0)
        self.$store.commit('provider/setShiftFormTimeAmPm', ampm)
      }

      self.$store.commit('provider/setShiftFormTitle', 'Creating Availability')
      self.$store.commit('provider/setShiftFormIsEdit', false)
      self.$store.commit('provider/setShiftFormSave', false)
      self.$store.commit('provider/setShiftFormForHomeSector', false)
      self.$store.commit('provider/setShiftFormShow', true)
    },
    editShift (driverShift) {
      let self = this
      if (!self.editEnabled) { return }
      self.$store.commit('provider/setShiftFormSelectedSector', driverShift.workSectorId)
      self.$store.commit('provider/setShiftFormSelectedSubsector', driverShift.workSubsectorId)
      self.$store.commit('provider/setShiftFormShiftId', driverShift.id)
      self.$store.commit('provider/setShiftFormShiftDuration', driverShift.duration)

      self.$store.commit('provider/setShiftFormShiftDay', driverShift.start.toDate())
      self.$store.commit('provider/setShiftFormTimeHour', parseInt(driverShift.start.format('hh')))
      self.$store.commit('provider/setShiftFormTimeMinute', parseInt(driverShift.start.format('mm')))
      self.$store.commit('provider/setShiftFormTimeAmPm', driverShift.start.format('A'))

      let title = 'Editing ' + driverShift.start.format('MM/DD/YYYY hh:mmA') + ' - ' + driverShift.end.format('hh:mmA') + ' availability'
      self.$store.commit('provider/setShiftFormTitle', title)
      self.$store.commit('provider/setShiftFormIsEdit', true)
      self.$store.commit('provider/setShiftFormSave', false)
      self.$store.commit('provider/setShiftFormForHomeSector', false)
      self.$store.commit('provider/setShiftFormShow', true)
    },
    populateHomeSector () {
      let self = this
      let homeSectorId = self.$store.state.provider.basicInfo.homeSectorId
      if (homeSectorId === null) {
        self.homeSector = null
        return
      }
      let sectors = self.$store.state.provider.shiftForm.sectors
      for (let i = 0; i < sectors.length; i++) {
        let sector = sectors[i]
        if (sector.ID === homeSectorId) {
          self.homeSector = sector.name
          return
        }
      }
      self.homeSector = null
    },
    dateFormat (val) { return moment(val).format('MM/DD/YYYY') }
  },
  watch: {
    provId: function (value) {
      this.populateHomeSector()
      if (this.active && this.loaded !== value) {
        this.loaded = this.provId
        this.initialize()
      }
    },
    homeSectorId: function (value) {
      if (value === null) {
        return
      }
      this.populateHomeSector()
    },
    isShiftFormSaved (value) {
      if (!value) {
        return
      }
      this.filterShifts()
    },
    active (val) {
      if (val && this.loaded !== this.provId) {
        this.loaded = this.provId
        this.initialize()
      }
    }
  },
  mounted () {
    let self = this
    // self.initialize()

    self.$store.commit('provider/setShiftFormSectors', [])
    self.$sdk.get('/sectors', {
      token: self.$store.state.session.sessionToken,
      pageSize: 50
    }, r => {
      if (r.error) {
        return
      }
      self.$store.commit('provider/setShiftFormSelectedSector', -1)
      self.$store.commit('provider/setShiftFormSectors', r.list)
      self.populateHomeSector()
    })
  }
}
</script>

<style lang="scss" scoped>

$cell-height: 74px;
$cell-width: 60px;
$cell-border-color: rgba(0,0,0,0.3);
$row-width: 1444px;

.home-sector {
  font-size: 14px;
  margin-top: 15px;
  cursor: pointer;

  &.disabled { cursor:default; }
  & > div > * {
    display: inline-block;
    vertical-align: middle;
  }

  & > div > i.fa-home {
    background-color: #26D97A;
    width: 25px;
    height: 25px;
    text-align: center;
    line-height: 25px;
    color: #fff;
    border-radius: 100%;
    margin-right: 5px;
  }

  & > div > .highlight {
    font-weight: 700;
    color: #0D79F2;
  }

  & .none {
    color: #F25E0D;
    font-weight: 700;
  }

  & .fa-edit { color: #0D79F2; }
}
.shifts {
  margin-top: 20px;
  width: 100%;
  position: relative;
  border: 2px solid rgba(0,0,0,0.55);
}
.shift-day-empty {
  width: 60px;
  height: 30px;
  background-color: #f5f5f5;
  border: 1px solid $cell-border-color;
  border-left: 0;
}
.shift-day {
  width: 60px;
  background-color: #f5f5f5;
  // color: #fff;
  text-align: center;
  border: 1px solid $cell-border-color;
  border-top: 0;
  border-left: 0;
  padding: 10px 0;
  & .date {
    font-size: 20px;
    line-height: 20px;
    font-weight: 700;
    margin-bottom: 5px;
    color: #0D79F2;
  }

  & .month {
    font-size: 14px;
    line-height: 14px;
    font-weight: 700;
    margin-bottom: 2px;
    color: #777;
  }

  & .day {
    font-size: 12px;
    line-height: 12px;
    font-weight: 700;
    color: #333;
  }
}

.driver-shift {
  position: absolute;
  z-index: 5;
  height: 74px;
  padding: 10px 0;

  & .shift-content {
    background-color: #F25E0D;
    color: #fff;
    font-weight: 700;
    padding: 10px;
    transition: all 250ms;
    cursor: pointer;
    width: 100%;

    &:hover { background-color: #D05E0D; }

    &.confirmed {
      background-color: #26CF7A;
      &:hover { background-color: #26B67A; }
    }
  }

  & .time {
    font-size: 14px;
    line-height: 14px;
    margin-bottom: 6px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
  }

  & .place {
    font-size: 12px;
    line-height: 12px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
  }
}

.shift-times-wrapper {
  overflow-y: hidden;
  overflow-x: auto;
  position: absolute;
  top: 0;
  left: 60px;
  width: calc(100% - 60px);
  z-index: 3;
}
.shift-times {
  width: $row-width;
  & .time-label {
    font-size: 10px;
    font-weight: 700;
    color: #555;
    width: $cell-width;
    border: 1px solid $cell-border-color;
    padding: 7px 0 6px;
    display: inline-block;
    text-align: center;
    border-left: 0;
    &:not(:first-child) { margin-left: -4px; }
    &:last-child{ border-right: 0; }
  }
}
.shift-placeholder-row{
  position: relative;
  width: $row-width;
  height: $cell-height;
  & .shift-placeholder {
    position: static;
    width: $cell-width;
    height: $cell-height;
    display: inline-block;
    border: 1px solid $cell-border-color;
    border-top: 0;
    border-left: 0;
    cursor: pointer;
    background-color: rgba(255,255,255,0);
    transition: all 250ms;
    &:hover { background-color: rgba(0,0,0,0.03); }
    &:not(:first-child) { margin-left: -4px; }
    &:last-child{ border-right: 0; }
  }

  & .shift-item {
    position: absolute;
    top: 10px;
    left: 0;
    height: 30px;
    width: 10%;
    background-color: red;
  }
}
.shift-times-wrapper.disabled .shift-placeholder { cursor: default; }

.field-input {
  & label {
    color: #0D79F2;
    font-weight: 700;
    font-size: 10px;
  }

  & input {
    margin-top: 0;
    font-size: 14px;
    padding: 7px 7px;
  }

  select {
    font-size: 14px;
    height: 37px;
    outline: 0;
    padding: 7px 7px;
    display: block;
    border-color: rgba(0,0,0,0.15);
    background-color: #fff;
    border-radius: 3px;
  }
}

.filter-btn {
  margin-top: 25px;
  position: relative;

  & > * {
    display: inline-block;
    vertical-align: middle;
  }

  & i {
    position: absolute;
    top: 9px;
    right: 15px;
  }
}

.padding-R { padding-right: 7px; }
.padding-L { padding-left: 7px; }
.margin-T { margin-top: 20px; }

@media only screen and (max-width: 430px) {
  .shift-header {
    display: flex;
    flex-direction: column;
    
    .columns {
      width: 100% !important;
      padding: 0 !important;
    }
    
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Provider/Shifts.vue